'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.toDisplayName = toDisplayName;
exports.toInitialState = toInitialState;
exports.toProps = toProps;
exports.toDefaultProps = toDefaultProps;
exports.toUnmount = toUnmount;
function toDisplayName(decorators, BaseComponent) {
  var names = decorators.map(function (_ref) {
    var displayName = _ref.displayName;
    return displayName();
  });
  return 'Decorated(' + names.join(' -> ') + ')(' + BaseComponent.displayName + ')';
}

function toInitialState(decorators, props, setState, context) {
  var result = decorators.reduce(function (state, _ref2, index) {
    var initialState = _ref2.initialState;

    if (typeof initialState === 'function') {
      state[index] = initialState(props, setState.bind(null, index), context);
    }
    return state;
  }, {});
  return result;
}

function toProps(decorators, props, state, setState, context) {
  return decorators.reduce(function (coll, _ref3, index) {
    var nextProps = _ref3.nextProps;
    return nextProps(coll, state[index], setState.bind(null, index), context);
  }, props);
}

function applyMeta(fieldName, decorators, BaseComponent) {
  return decorators.reduce(function (result, decorator) {
    var meta = decorator[fieldName];
    return meta ? meta(result || {}) : result;
  }, BaseComponent[fieldName]);
}

function getOriginalDefaults(_ref4) {
  var defaultProps = _ref4.defaultProps;
  var getDefaultProps = _ref4.getDefaultProps;

  if (defaultProps && (typeof defaultProps === 'undefined' ? 'undefined' : _typeof(defaultProps)) === 'object') {
    return defaultProps;
  }
  if (typeof getDefaultProps === 'function') {
    return getDefaultProps();
  }
  return {};
}

function toDefaultProps(decorators, BaseComponent) {
  return decorators.reduce(function (prev, _ref5) {
    var defaultProps = _ref5.defaultProps;

    if (typeof defaultProps === 'function') {
      return defaultProps(prev);
    }
    return prev;
  }, getOriginalDefaults(BaseComponent));
}

var toContextTypes = exports.toContextTypes = applyMeta.bind(null, 'contextTypes');

var toPropTypes = exports.toPropTypes = applyMeta.bind(null, 'propTypes');

function toUnmount(decorators, props, state, context) {
  decorators.forEach(function (_ref6, index) {
    var unmount = _ref6.unmount;

    if (typeof unmount === 'function') {
      unmount(props, state[index], context);
    }
  });
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-decorate/lib/fields.js
 ** module id = 720
 ** module chunks = 0
 **/